import styled from 'styled-components';
import { Box, Text, FakeLinkComponent } from '@rsos/components/capstone/base';

export const Backdrop = styled(Box).attrs({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  bg: 'foreground',
  align: 'center',
  justify: 'center',
  opacity: 0.9,
})`
  z-index: 200;
  height: ${({ height }) => height || '100vh'};
`;
export const AccessDeniedOverlayContent = styled(Box).attrs({
  display: 'flex',
  align: 'center',
  justify: 'center',
  width: 512,
})``;

export const TextExcerpt = styled(Text).attrs({
  color: 'primaryText',
  textAlign: 'center',
  size: 'normal',
})``;

export const Link = styled.a`
  color: ${p => p.theme.colors.primaryBase};
  text-decoration: underline;
  &:hover {
    color: ${p => p.theme.colors.primaryBaseC2};
  }
`;
export const FakeLink = styled(FakeLinkComponent)`
  text-decoration: underline;
`;
